<template>
	<div id="app">

		<HNB single-title="售后政策"></HNB>
		<div style="max-height: 16.5rem; overflow: hidden; display: flex; justify-content: center; align-items: center;">
			<img style="width: 100%;" :src="img">
		</div>
		<div id="introduce">
			<div class="title">

				<div class="box" v-for="(item,i) in list" :key="item.name" @click="choose(i)">
					<!-- <div> -->
					<div class="spanbox">
						<span :class="{'active':currentindex==i}">{{item}}</span></div>
					<div class="line" v-if="i<(list.length-1)">|</div>
					<!-- </div> -->
					<!-- <div class="hide"></div> -->
				</div>



			</div>
			<div class="write" v-show="this.currentindex==0">
				<div class="span">
					感谢您使用乐范产品，我们将根据《中华人民共和国产品质量法》、《中华人民共和国消费者权益保护法》及《部分商品修理、更换、退货责任规定》（即新 “三包”规定），为用户提供全方位服务，实行全面三包，为您提供不低于国家三包政策的服务。<br>
					<br />
					一、7 天无理由退换货<br>
					客户在线上购物平台官方直营或官方授权的店铺购买的乐范产品，自签收的次日零点起（7 天期间自买家签收商品后的次日零时开始起算，满 168 小时为 7
					天，买家签收商品时间以物流签收时间为准），按照《消法》及《网络购买商品七日无理由退货暂行办法》要求，为您提供 7 天内无理由退换货服务。<br>
					乐范产品享受 7 天内无理由退换货服务的必要条件，退回产品未受到人为损坏；需经乐范客户服务中心检测，退回产品未收到人为损坏后，方可办理退换货。<br>
					<br>
					不予办理 7 天无理由退换货的情况说明:<br>
					1）经检测产品有明显外观损伤等人为损坏痕迹的乐范产品；<br>
					2）退回的产品序列号与出库序列号不符的乐范产品；<br>
					3）未经授权的拆机、维修，误用、碰撞、进液、事故及不正确安装、使用所造成的商品质量问题，或撕毁、涂改标贴、产品序列号、说明书保修卡等；<br>
					4）原外包装不完整，标准配件不齐全；<br>
					5）随订单赠送的赠品，未能如数退回，赠品包装不完整 (消费者同意支付赠品价款的除外);<br>
					6）购买时，页面明确说明不支持退换货的商品。
				</div>
			</div>
			<div class="write" v-show="this.currentindex==1">
				<div class="span">
					自购机之日起，七天内主机产品出现非人为导致的主机性能故障，在产品包装、附件和有效购买凭证齐全的情况下，依据用户的意愿可享受退货或免费换货服务，换货后新主机产品的三包有效期自换货之日起重新计算。七天内首次受理时未复现用户描述故障，如在首次受理后七天内复现同一故障，则退换机有效期以首次受理时间为准。<br>
					<br>
					自购机之日起，十五天内主机产品出现非人为导致的主机性能故障，在产品包装、附件和有效购买凭证齐全的情况下，依据用户的意愿可享受免费换货服务，换货后新主机产品的三包有效期自换货之日起重新计算；十五天内首次受理时未复现用户描述故障，如在首次受理后十五天内复现同一故障，则换机有效期以首次受理时间为准。<br>
					<br>
					不予办理 7 天退换货以及 15天换货的情况说明:<br>
					1）未经授权的拆机、维修，误用、碰撞、进液、事故及不正确安装、使用所造成的商品质量问题，或撕毁、涂改标贴、产品序列号、说明书保修卡等；<br>
					2）第三方问题原因造成的不良（非官方或适配标准充电器、非官方标准充电线、非官方的魔力贴贴片等）；<br>
					3）附件本身问题（如：附件数据线不良等），不作为退换主机的条件，您可要求更换新的附件；
				</div>
			</div>
			<div class="write" v-show="this.currentindex==2">
				<div class="span">
					自购买日起一年内，乐范产品出现非人为导致的主机性能故障，在提供有效购机凭证和保修卡，经乐范客户服务中心检测确认，符合三包条件，由乐范客户服务中心为您免费保修。<br>
					在三包有效期内免费保修后或使用超过一年正常过保（无进液、外力导致、私自拆装等情况）付费维修的乐范产品，产生维修记录后的乐范产品享受原有 12 个月保修期的剩余时长或 90
					天的保修期，以其中时间较长者为准，如果有更换主板，则主板享受原有 12 个月保修期的剩余时长或 180 天的保修期，以其中时间较长者为准。<br>
					 <br>
					非正常过保（如进液、外力导致、私自拆修等造成不良）的乐范产品，用户付费更换损坏部件后，保修期详细如下：<br>
					主板更换维修时，主板保修 180 天，除主板和电池之外的其他部件保修 90 天；<br>
					主板不更换维修时，仅针对更换的部件保修 90 天，其余部件均不保修；
					<br><br>
					产品因以下行为产生的故障，无法享受以上的三包政策，实行收费维修：<br>
					1）超出三包有效期；<br>
					2）产品进液、受潮腐蚀；<br>
					3）产品受外力导致损伤（如外观破损、变形等）；<br>
					4）私自拆机、第三方维修；<br>
					5）产品系统内序列号或保修标示贴丢失或被更改；<br>
					6）不可抗拒外力（如水灾、火灾、地震、雷击等强烈震动或挤压）等因素造成的物理损坏及故障，如摔坏或压坏、变形等情况；<br>
					7）在销售时已明确告知不实行免费保修的产品；<br>
				</div>

			</div>
			<div class="write" v-show="this.currentindex==3">
				<div class="span">
					1）有效的保卡及发票是实现您三包权益的基本保证，请您妥善保管；<br>
					2）如果您丢失发票和三包凭证，且不能提供有效发票和三包凭证复印件，我们将依据内部销售系统erp订单的物流签收日期作为为购买日期，为您的产品提供一年期的免费保修服务；<br>
					3） 乐范公司对产品的其他配件，除充电器、数据线、电池外，不承担三包责任；充电器、数据线质保时间为1年，电池的质保期限为6个月。<br>
					4）所有附件产品，在三包有效期内进行过换货处理的自换货之日起重新计算三包期，更换两次仍然无法正常使用的，可要求按照单独销售价退货。<br>
					5）附件（酷炫版贴片、温情版贴片）等导致的主机局部功能受影响或工作不正常的，不能作为退换机的条件，您可要求更换新的附件。如因用户使用不当或意外因素造成电源适配器或电池有明显的硬物损伤，裂痕，断脚，变形等，电源线破损，短线，裸芯等现象则不予保修，用户可另行购买。<br>
				</div>

			</div>

			<div class="write" v-show="this.currentindex==4">
				<div class="span">
					1）本服务政策若与国家法律法规存在冲突之处，一切以国家法律法规为准；<br>
					2）我们随时根据国家政策变化，调整有利于用户的服务政策；<br>
				</div>

			</div>
		</div>
		<BS :BsTitle="bsTitle"></BS>

	</div>
</template>

<script>
	import HNB from '../components/HeaderNavigationBar.vue'
	import BS from '../components/bottomShow.vue'
	export default {
		name: "app",
		components: {
			HNB,

			BS

		},
		data() {
			return {
				list: ['7天无理由退换货', '15天换货', '一年保修', '保修说明及原则', '说明'],
				currentindex: '',

				bsTitle: ['服务支持', '售后政策'],
				img: this.GLOBAL.imgHost + '/images/background.png',
			}

		},
		methods: {
			choose(index) {
				this.currentindex = index;

			}

		}
	}
</script>

<style>
	#introduce {
		width: 100%;
		/* height: 21.875rem; */
		margin-top: 2%;
	}

	#introduce .title .box {
		font-family: Alibaba-PuHuiTi-M;
		width: 10rem;
		height: 3.125rem;
		float: left;
		position: relative;
		top: 20%;
		cursor: pointer;
		text-align: center;
		display: flex;
	}

	#introduce .box .spanbox {
		width: 10rem;
		height: 1.875rem;
		font-size: 1.1rem;
		 
		font-weight: 500;
		color: rgba(24, 24, 24, 1);
		line-height: 1.875rem;
		/* float: left; */
		text-align: center;
	}

	#introduce .title hr {
		width: 0.0625rem;
		height: 0.6875rem;
		background: rgba(0, 0, 0, 1);
		opacity: 0.2;
		float: left;
	}

	#introduce .line {
		height: 0.6875rem;
		opacity: 0.2;
		line-height: 1.875rem;
	}

	#introduce .hide {
		width: 2.8125rem;
		height: 0.125rem;
		position: relative;
		top: 85%;
		left: 25%;

	}

	#introduce .box span.active {
		border-bottom: 0.1rem #00C785 solid;
		padding-bottom: 1.5rem;

	}


	#introduce .title {
		width: 53.75rem;
		height: 5.9375rem;
		margin: 0 auto;
	}

	#introduce .write {

		max-width: 58.75rem;
		height: 30rem;
		background: rgba(250, 250, 250, 1);
		margin: 0 auto;
		text-align: left;
		margin-bottom: 3.125rem;

	}

	#introduce .write .span {
		height: 25rem;
		overflow: auto;
		font-size: 0.9rem;
		 
		font-weight: 400;
		color: rgba(24, 24, 24, 1);
		line-height: 1.875rem;
		padding: 25px;
	}
</style>
